const INVALID_TOKEN_MESSAGE = 'Invalid token';
const INVALID_CREDENTIALS_MESSAGE = 'Invalid credentials';

interface HttpErrorLike {
  isAxiosError?: boolean;
  response?: { status?: number; data?: { message?: unknown } | string | null };
}

/**
 * True when the backend says the session is no longer valid: a 401, or a 403 with the message `Invalid token`
 * (expired, revoked or malformed token, user deactivated). Only these errors end the session. A network error, a
 * timeout or a 5xx is not an auth error: the session stays and the request can be tried again.
 *
 * `Invalid credentials` is a wrong password on the login form, not a session error.
 *
 * Checks the shape instead of `instanceof AxiosError`, so modules that mock `axios` in tests still work.
 */
export const isAuthError = (error: unknown): boolean => {
  const { isAxiosError, response } = (error ?? {}) as HttpErrorLike;
  if (isAxiosError !== true || !response) return false;

  const message = typeof response.data === 'object' ? response.data?.message : undefined;
  if (message === INVALID_CREDENTIALS_MESSAGE) return false;

  return response.status === 401 || message === INVALID_TOKEN_MESSAGE;
};
